module.exports = __webpack_public_path__ + "static/media/gasflame.1f105ddb.png";